var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"gradient tw-relative",attrs:{"dark":""}},[_c('div',{staticClass:"tw-min-h-[100vh] tw-flex tw-flex-col"},[_c('Header'),_c('main',{staticClass:"pt-0"},[_vm._t("default")],2)],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }